import { Component } from "../Component.js";

class Toast {

    static TYPE_ERROR = 'error';
    static TYPE_INFO = 'info';
    static TYPE_SUCCESS = 'success';
    static TYPE_WARNING = 'warning';

    constructor(toaster, options = {}) {

        const {
            active = true,
            type = Toast.TYPE_INFO,
            message = null,
            title = null,
            id = null,
            timeOut = 5000,
            autoclose = true,
            closeButton = true,
            details = null
        } = options;

        this.toaster = toaster;

        this.active = true;
        this.message = message;
        this.id = id;
        this.type = type;
        this.title = title;
        this.timeOut = timeOut;
        this.autoclose = autoclose;
        this.closeButton = closeButton;
        this.details = details;

    };

}

// --------------------------------------------------------------------------------------------

export class Toaster extends Component {

    static POSITION_TOP_LEFT = 'top-left';
    static POSITION_TOP_CENTER = 'top-center';
    static POSITION_TOP_RIGHT = 'top-right';
    static POSITION_BOTTOM_LEFT = 'bottom-left';
    static POSITION_BOTTOM_CENTER = 'bottom-center';
    static POSITION_BOTTOM_RIGHT = 'bottom-right';

    constructor(parent, options = {
        position: Toaster.POSITION_BOTTOM_RIGHT,
        toastTimeOut: 5000,
    }) {

        super(parent, options);

        const {
            position,
            toastTimeOut,
        } = options;

        this.position = position;
        this.toastTimeOut = toastTimeOut;
        this.toasts = [];
        this.toastId = 0;

    };

    // --------------------------------------------------------------------------------------------

    error(message, title, options) {
        return this.createToast(Toast.TYPE_ERROR, message, title, options);
    };

    warning(message, title, options) {
        return this.createToast(Toast.TYPE_WARNING, message, title, options);
    };

    info(message, title, options) {
        return this.createToast(Toast.TYPE_INFO, message, title, options);
    };

    success(message, title, options) {
        return this.createToast(Toast.TYPE_SUCCESS, message, title, options);
    };

    createToast(type, message, title, options = {}) {

        this.toastId++;

        var that = this,
            t = new Toast(this, {
                id: this.toastId,
                type: type,
                message: message,
                title: title,
                timeOut: this.toastTimeOut,
                details: options.details ?? null
            });

        this.toasts.push(t);
        this.invalidate();

        if (t.timeOut > 0) {
            t.timeOutInterval = setInterval(createTimeOutHandler(t), t.timeOut);
        }

        return t;

        function createTimeOutHandler(toast) {
            return function () {
                that.removeToast(toast);
            };
        };

    };


    removeToast(toast) {

        var index = this.toasts.indexOf(toast);
        if (index < 0)
            return;

        if (toast.timeOutInterval) {
            clearInterval(toast.timeOutInterval);
            toast.timeOutInterval = null;
        }
        this.toasts.splice(index, 1);

        this.invalidate();

    };

    getDefaults() {

        return {

            tapToDismiss: true,
            debug: false,


            extendedTimeOut: 1000,
            iconClasses: {
                error: 'toast-error',
                info: 'toast-info',
                success: 'toast-success',
                warning: 'toast-warning'
            },
            iconClass: 'toast-info',
            positionClass: 'toast-top-right',
            timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
            titleClass: 'toast-title',
            messageClass: 'toast-message',
            escapeHtml: false,
            target: 'body',
            closeHtml: '<button type="button">&times;</button>',
            closeClass: 'toast-close-button',
            newestOnTop: true,
            preventDuplicates: false,
            progressBar: false,
            progressClass: 'toast-progress',
            rtl: false

        };

    };

    // --------------------------------------------------------------------------------------------

    _render(r, vm) {

        const toaster = this;
        const css = `toast-container ${getContainerPosition(toaster.position)}`;

        return r.el('div', css, null,
            toaster.toasts.map(toast => renderToast(toast))
        );

        function renderToast(toast) {

            const css = [
                'toast',
                toast.active ? 'active' : null,
                getToastType(toast.type),
            ].filter(Boolean).join(' ');

            const content = [
                r.nav(null, [
                    r.span('max', [toast.message]),
                    r.iconButton('#close', {
                        css: 'icon transparent',
                        props: {
                            type: 'button',
                            onclick: (e) => {
                                e.preventDefault();
                                toast.active = false;
                                toaster.invalidate();
                                // animace
                                setTimeout(() => {
                                    toaster.removeToast(toast);
                                }, 1000);
                            }
                        }
                    })
                ]),
            ];

            if (toast.details && toast.details.length) {
                content.push(r.ul(toast.details.map((i) => r.li([i]))));
            }

            return r.el('div', css, {}, content);

        };

        function getContainerPosition(position) {

            switch (position) {
                case Toaster.POSITION_TOP_LEFT:
                    return 'toast-top-left';
                case Toaster.POSITION_TOP_CENTER:
                    return 'toast-top-center';
                case Toaster.POSITION_TOP_RIGHT:
                    return 'toast-top-right';
                case Toaster.POSITION_BOTTOM_LEFT:
                    return 'toast-bottom-left';
                case Toaster.POSITION_BOTTOM_CENTER:
                    return 'toast-bottom-center';
                default:
                    return 'toast-bottom-right';
            }

        };

        function getToastType(type) {

            switch (type) {
                case Toast.TYPE_ERROR:
                    return 'error';
                case Toast.TYPE_SUCCESS:
                    return 'success';
                case Toast.TYPE_WARNING:
                    return 'warning';
                default:
                    return 'primary';
            }

        };

    };

}